<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('my.information_announcement')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="!noticeList.length"
          :description="$t('withdraw.empty_data')"
        />
        <div class="listItem" v-for="(v, key) in noticeList" :key="key">
          <div class="listTitle">{{ v.name }}</div>
          <div class="listContent">{{ v.text }}</div>
          <div class="listTime">{{ v.create_time }}</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice: [],
    };
  },
  computed: {
    noticeList() {
      if (Array.isArray(this.notice)) return this.notice;
      if (this.notice && typeof this.notice === "object") {
        return Object.values(this.notice);
      }
      return [];
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    getNoticeList() {
      this.$http({ method: "get", url: "sys_get_notice_list" }).then((res) => {
        this.notice = res.data || [];
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    this.getNoticeList();
  },
};
</script>

<style lang="less" scoped>
.sub-page {
  min-height: 100vh;
  background: #000000;
  padding-bottom: 40px;
}
.content {
  padding: 24px;
}
.listItem {
  background: #141414;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 20px;
  color: #c9a84c;
}
.listTitle {
  font-size: 34px;
  font-weight: 600;
  margin-bottom: 12px;
}
.listContent {
  font-size: 28px;
  color: #666;
  line-height: 1.5;
  padding-bottom: 16px;
  border-bottom: 1px solid #000000;
}
.listTime {
  margin-top: 14px;
  text-align: right;
  color: #999;
  font-size: 26px;
}
</style>
